import moment from 'moment'

// Rótulos e cores dos estados do mecanismo de entrega automática (os enums chegam da API como
// texto). Um único mapa para todo o painel.
export const autoDeliveryStateLabels = {
  None: { text: 'Fora do automático', variant: 'secondary' },
  Waiting: { text: 'Aguardando', variant: 'info' },
  Dispatching: { text: 'Acionando', variant: 'info' },
  SupplierRequested: { text: 'Solicitado ao fornecedor', variant: 'primary' },
  SupplierAccepted: { text: 'Aceito pelo fornecedor', variant: 'success' },
  ManualHandling: { text: 'Tratativa manual', variant: 'warning' },
  Completed: { text: 'Concluído', variant: 'success' },
}

export const workStateLabels = {
  Scheduled: { text: 'Agendado', variant: 'info' },
  Queued: { text: 'Na fila', variant: 'info' },
  Processing: { text: 'Processando', variant: 'primary' },
  RetryPending: { text: 'Aguardando nova tentativa', variant: 'warning' },
  Completed: { text: 'Concluído', variant: 'success' },
  ManualHandling: { text: 'Tratativa manual', variant: 'warning' },
  DeadLettered: { text: 'DLQ', variant: 'danger' },
  Canceled: { text: 'Cancelado', variant: 'secondary' },
}

export const dispatchStateLabels = {
  Pending: { text: 'Pendente', variant: 'info' },
  Calling: { text: 'Chamando', variant: 'info' },
  Created: { text: 'Criado', variant: 'primary' },
  RetryPending: { text: 'Nova tentativa', variant: 'warning' },
  OutcomeUnknown: { text: 'Resultado desconhecido', variant: 'danger' },
  Failed: { text: 'Falhou', variant: 'danger' },
  Accepted: { text: 'Aceito', variant: 'success' },
  CancellationPending: { text: 'Cancelando', variant: 'warning' },
  Canceled: { text: 'Cancelado', variant: 'secondary' },
  CancellationFailed: { text: 'Falha no cancelamento', variant: 'danger' },
}

export const ineligibilityReasonLabels = {
  PackageCountExceeded: 'Volumes acima do limite',
  ContainsLendingOrRent: 'Contém comodato ou locação',
  NoActiveDeliverySupplier: 'Sem fornecedor de delivery ativo',
  StorePreparing: 'Loja assumiu a entrega (Preparando)',
}

export const deliveryStatusLabels = {
  Pending: 'Pendente',
  Preparing: 'Preparando',
  InProgress: 'Entregando',
  Completed: 'Entregue',
  Canceled: 'Cancelado',
}

// Alertas de saúde (§4.3), na ordem de exibição.
export const alertLabels = {
  OverdueWork: { text: 'Works atrasados', hint: 'Na fila há mais de 2 min além do horário previsto.' },
  ExpiredWorkLease: { text: 'Lease de work expirado', hint: 'Processamento abandonado por um worker.' },
  DeadLetteredWork: { text: 'Works na DLQ', hint: 'Enviados à fila de mensagens mortas nas últimas 24 h.' },
  UnansweredDispatch: { text: 'Fornecedor sem resposta', hint: 'Pedido ao fornecedor sem aceite nem falha há mais de 5 min.' },
  OutcomeUnknownDispatch: { text: 'Resultado desconhecido', hint: 'O pedido pode existir no fornecedor sem estar vinculado.' },
  CancellationFailure: { text: 'Falha de cancelamento', hint: 'Risco de entrega duplicada ou cobrança indevida.' },
  StalledOutbox: { text: 'Outbox parado', hint: 'Evento não publicado há mais de 1 min.' },
}

export const label = (map, value) => map[value]?.text || map[value] || value || '-'
export const variant = (map, value) => map[value]?.variant || 'secondary'

export const formatDateTime = value => (value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-')

export const formatDuration = seconds => {
  if (seconds === null || seconds === undefined) return '-'
  const total = Math.round(seconds)
  if (total < 60) return `${total} s`
  const minutes = Math.floor(total / 60)
  if (minutes < 60) return `${minutes} min ${total % 60} s`
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`
}

export const formatAge = value => (value ? formatDuration(moment().diff(moment(value), 'seconds')) : '-')
